import _ from 'lodash';
import moment from 'moment';

//import firebase from 'firebase';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';

import { detect } from 'detect-browser';

import * as Sentry from '@sentry/browser';
import passwordGenerator from 'password-generator';

import { FullStoryAPI } from 'react-fullstory';

import APP_CONFIG from '../config';

import store from '../store';

const CONFIG = APP_CONFIG;

//export util files
export * from './dealScoring';

export function appConfig(){
  return CONFIG;
}

export function isProduction(){
  return CONFIG.ENV === 'production';
}

export function isDemo(){
  return CONFIG.ENV === 'demo';
}

export function isDevelopment(){
  return CONFIG.ENV !== 'production';
}

export function print(){
  if(getBrowserName() !== 'safari'){
    window.print();
  }
  else{
    //have to "stop" network requests immediately before attempting to print, otherwise safari
    //tries to wait for network requests to complete (which the never do)
    console.log('STOPPING page load in order to print in Safari');
    window.stop();
    window.print();
  }
}

export function getAppVersion(){
  return (!isProduction() ? (CONFIG.ENV + ' ') : 'BETA ') + 'V' + CONFIG.VERSION;
}

//UTC timestamp in seconds
export function getCurrentTimestamp(){
  //https://firebase.google.com/docs/firestore/manage-data/add-data
  return firebase.firestore.FieldValue.serverTimestamp();
}

export function getCurrentTime(){
  return moment().valueOf();
}

//https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/
export function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
export function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
export function deleteCookie(name){
  setCookie(name, '', -1);
}

export function getBrowserName(){
  const browser = detect();

  return (browser || {}).name
}
export function getWindowDimensions(){
  //https://stackoverflow.com/questions/1766861/find-the-exact-height-and-width-of-the-viewport-in-a-cross-browser-way-no-proto

  var viewPortWidth;
  var viewPortHeight;

  // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
  if (typeof window.innerWidth != 'undefined') {
   viewPortWidth = window.innerWidth,
   viewPortHeight = window.innerHeight
  }

  // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
  else if (typeof document.documentElement != 'undefined'
  && typeof document.documentElement.clientWidth !=
  'undefined' && document.documentElement.clientWidth != 0) {
    viewPortWidth = document.documentElement.clientWidth,
    viewPortHeight = document.documentElement.clientHeight
  }

  // older versions of IE
  else {
   viewPortWidth = document.getElementsByTagName('body')[0].clientWidth,
   viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
  }
  return {
    width: viewPortWidth,
    height: viewPortHeight
  };
}
export function isUnsupportedDevice(){
  const dimensions = getWindowDimensions();
  return dimensions.width < 960 || dimensions.height < 600;
}
export function isUnsupportedBrowser(){
  const browserName = getBrowserName();

  if( browserName === 'chrome' ||
      browserName === 'firefox' ||
      browserName === 'safari'
  ){
    return false;
  }

  return true;
}

export function ifCallbackIsFunction(callback, props = undefined){
  if(typeof callback === 'function'){
    callback(props);
  }
}

export function momentIsBetweenDatesInclusive(compare, start, end){
  const oneBeforeStart = moment(start).subtract('days', 1);
  const oneAfterEnd = moment(end).add('days', 1);

  return moment(compare).isBetween(oneBeforeStart, oneAfterEnd);
}

export function getSprintStatusTextForEmployee(status){
  console.log('getSprintStatusTextForEmployee: ', status);
  if(status === 'editing'){
    return 'Editing sprint';
  }
  else if(status === 'submitted'){
    return 'Sprint submitted';
  }
  else{
    return 'Sprint not setup';
  }
}

export function actionPlanSetupForSprint(sprint){
  if(!sprint || !sprint.goals || !sprint.goals[0]){
    return false;
  }

  const goalExistsWithoutActionPlan = _.find(sprint.goals, goal => {
    //if behavior or skill goal, and no action plan or smart goal configured
    return  (goal.category === 'behavior' || goal.category === 'skill') &&
            (!goal.goalMeta ||
            !goal.goalMeta.actionPlan ||
            goal.goalMeta.actionPlan === '' ||
            !goal.goalMeta.smartGoal ||
            goal.goalMeta.smartGoal === '');
  }) ? true : false;

  if(goalExistsWithoutActionPlan){
    return false;
  }
  else{
    //at least one goal and no goals exists without action plan
    return true;
  }
}

export function firstWeeklyReviewConductedForSprint(sprint){
  if(!sprint || !sprint.goals || !sprint.goals[0] || !sprint.thisWeekActionItems || sprint.thisWeekActionItems === ''){
    return false;
  }
  else{
    return true;
  }
}

export function formatNewLines(text){
  if(text){
    return text.replace(/(\r\n|\n|\r)/gm, '<br />');
  }
  else{
    return '';
  }
}

export function getRatingClass(rating, maxRating){
  const ratingAsPercentage = (rating / (maxRating || 5)) * 100.0;

  // console.log('ratingAsPercentage', ratingAsPercentage);

  if(ratingAsPercentage >= 90){
    return 'perfect';
  }
  else if(ratingAsPercentage >= 75){
    return 'great';
  }
  else if(ratingAsPercentage >= 50){
    return 'average';
  }
  else if(ratingAsPercentage >= 25){
    return 'below-average';
  }
  else{
    return 'poor';
  }
}

export function getDefaultTalentRatingExplanationForValue(val){
  return getDefaultTalentRatingExplanations()[val - 1];
}

export function getDefaultTalentRatingExplanations(){
  // return [
  //   'Does not apply or is extremely ineffective',
  //   'Rarely applies or is ineffective',
  //   'Infrequently applies with average effectiveness',
  //   'Sometimes applies with average effectiveness',
  //   'Often applies and is moderately effective',
  //   'Often applies and is highly effective',
  //   'Consistently applies and is extremely effective'
  // ];
  return [
    'Extremely Ineffective',
    'Very Ineffective',
    'Below Average Effectiveness',
    'Average Effectiveness',
    'Above Average Effectiveness',
    'Very Effective',
    'Extremely Effective',
  ];
}

export function calculateLikelySprintStartAndEndDatesFromCurrentDate(){
  return {
    startDate: moment().startOf('isoWeek').subtract(7, 'days').valueOf(),
    endDate: moment().startOf('isoWeek').subtract(3, 'days').valueOf(),
  }
}

export function focusAfterTimeout(self, ref, timeout = 50){
  setTimeout(() => {
    // console.log('attempting focus');
    // console.log(ref);
    // console.log(self[ref]);
    // console.log(self[ref].focus);
    self[ref] && self[ref].focus && self[ref].focus();
  }, 50);
}

export function isNumerical(string){
  const numbersOnlyRegex = /^\d+$/;
  return numbersOnlyRegex.test(string);
}

export function formatThousands(num){
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function goalValueIsSet(goalValue){
  return goalValue !== undefined && goalValue !== '';
}

export function organizationGoalsAreDirty(cachedGoals, updatedGoals){
  let isDirty = false;

  _.each(cachedGoals, cachedGoal => {
    const matchingUpdatedGoal = _.find(updatedGoals, updatedGoal => {
      return updatedGoal.id === cachedGoal.id;
    });

    if(!matchingUpdatedGoal){
      isDirty = true;
    }
    else{
      // console.log('checking ', cachedGoal.ratings);
      // console.log('with ', matchingUpdatedGoal.ratings);

      //check whether goal inactive same in both
      if( cachedGoal.inactive !== matchingUpdatedGoal.inactive ||
          cachedGoal.name !== matchingUpdatedGoal.name ||
          cachedGoal.description !== matchingUpdatedGoal.description ||
          cachedGoal.definition !== matchingUpdatedGoal.definition ||
          !_.isEqual(cachedGoal.ratings, matchingUpdatedGoal.ratings)
      ){
        isDirty = true;
      }
    }
  });

  _.each(updatedGoals, updatedGoal => {
    const matchingCachedGoal = _.find(cachedGoals, cachedGoal => {
      return cachedGoal.id === updatedGoal.id;
    });

    if(!matchingCachedGoal){
      isDirty = true;
    }
    else{
      //check whether goal inactive same in both
      if( updatedGoal.inactive !== matchingCachedGoal.inactive ||
        updatedGoal.name !== matchingCachedGoal.name ||
        updatedGoal.description !== matchingCachedGoal.description ||
        updatedGoal.definition !== matchingCachedGoal.definition ||
        !_.isEqual(updatedGoal.ratings, matchingCachedGoal.ratings)
      ){
        isDirty = true;
      }
    }
  });

  return isDirty;
}

export function sprintGoalsAreDirty(cachedGoals, updatedGoals){

  let isDirty = false;

  _.each(cachedGoals, cachedGoal => {
    const matchingUpdatedGoal = _.find(updatedGoals, updatedGoal => {
      return updatedGoal.id === cachedGoal.id;
    });

    if(!matchingUpdatedGoal){
      isDirty = true;
    }
    else{
      //check goals against eachother
      if(cachedGoal.goalTarget !== matchingUpdatedGoal.goalTarget){
        isDirty = true;
      }
      else if(goalValueIsSet(cachedGoal.goalValue) || goalValueIsSet(matchingUpdatedGoal.goalValue)){
        //if either value is set, compare
        if(cachedGoal.goalValue !== matchingUpdatedGoal.goalValue){
          isDirty = true;
        }
      }
      else{
        //else...check to make sure they're both falsy
        if(!(!cachedGoal.goalValue && !matchingUpdatedGoal.goalValue)){
          isDirty = true;
        }
      }

      //check meta values
      if(cachedGoal.goalMeta || matchingUpdatedGoal.goalMeta){
        if(!_.isEqual(cachedGoal.goalMeta, matchingUpdatedGoal.goalMeta)){
          isDirty = true;
        }
      }
    }
  });

  _.each(updatedGoals, updatedGoal => {
    const matchingCachedGoal = _.find(cachedGoals, cachedGoal => {
      return cachedGoal.id === updatedGoal.id;
    });

    if(!matchingCachedGoal){
      isDirty = true;
    }
    else{
      //check goals against eachother
      if(updatedGoal.goalTarget !== matchingCachedGoal.goalTarget){
        isDirty = true;
      }
      else if(goalValueIsSet(updatedGoal.goalValue) || goalValueIsSet(matchingCachedGoal.goalValue)){
        //if either value is set, compare
        if(updatedGoal.goalValue !== matchingCachedGoal.goalValue){
          isDirty = true;
        }
      }
      else{
        //else...check to make sure they're both falsy
        if(!(!updatedGoal.goalValue && !matchingCachedGoal.goalValue)){
          isDirty = true;
        }
      }

      //check meta values
      if(updatedGoal.goalMeta || matchingCachedGoal.goalMeta){
        if(!_.isEqual(updatedGoal.goalMeta, matchingCachedGoal.goalMeta)){
          isDirty = true;
        }
      }
    }
  });

  return isDirty;
}

export function getScoreClassificationInOrderedGroupScores(score, orderedGroupScores){
  let scoreClassification = 'none';

  //determine based on thresholds
  if(Math.round(score) >= 28){
    scoreClassification = 'high';
  }
  else if(Math.round(score) <= 18){
    scoreClassification = 'low';
  }

  //take top and bottom
  // if(Math.round(orderedGroupScores[0]) === Math.round(score)){
  //   scoreClassification = 'high';
  // }
  // else if(Math.round(orderedGroupScores[orderedGroupScores.length - 1]) === Math.round(score)){
  //   scoreClassification = 'low';
  // }

  return scoreClassification;
}

//https://stackoverflow.com/questions/37065663/array-of-object-deep-comparison-with-lodash
export function isArrayEqual(x, y) {
  return _(x).xorWith(y, _.isEqual).isEmpty();
};

//https://stackoverflow.com/questions/4878756/how-to-capitalize-first-letter-of-each-word-like-a-2-word-city/4878797
export function toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function getFourboxCategories(orderForAdmin = false){

  if(!orderForAdmin){
    return [{
      name: 'Behaviors',
      key: 'behavior'
    },{
      name: 'Activities',
      key: 'activity'
    },{
      name: 'Sales Skills',
      key: 'skill'
    },{
      name: 'Key Outcomes',
      key: 'outcome'
    }];
  }
  else{
    return [{
      name: 'Behaviors',
      key: 'behavior'
    },{
      name: 'Sales Skills',
      key: 'skill'
    },{
      name: 'Activities',
      key: 'activity'
    },{
      name: 'Key Outcomes',
      key: 'outcome'
    }];
  }
}

export function getFourboxTalentCategories(){
  return [{
    name: 'Behaviors',
    key: 'behavior'
  },{
    name: 'Sales Skills',
    key: 'skill'
  }];
}

export function getCategoryComponents(category){
  switch(category){
    case 'motivation':
      return ['ambition', 'persistence', 'competition', 'confidence'];
    break;
    case 'interaction':
      return ['networker', 'individualizer', 'advisor', 'team'];
    break;
    case 'cognition':
      return ['learning agility', 'analytical', 'adaptability', 'resourcefulness'];
    break;
    case 'execution':
      return ['focus', 'persuasion', 'responsibility', 'discipline'];
    break;
    default:
      return [];
    break;
  }
}

export function getDimensionIdForTalent(talent){
  switch(talent){
    //Motivation
    case 'confidence':
      return 'ExpectationMean';
      break;
    case 'ambition':
      return 'AchievementMean';
      break;
    case 'competition':
      return 'IntensityMean';
      break;
    case 'persistence':
      return 'PersistenceMean';
      break;

    //Interaction
    case 'networker':
      return 'InitiatorMean';
      break;
    // case 'responsiveness':
    //   return 'ServiceMean';
    //   break;
    case 'individualizer':
      return 'RelatorMean';
      break;
    case 'advisor':
      return 'DeveloperMean';
      break;
    case 'team':
      return 'TeamMean';
      break;

    //Cognition
    case 'analytical':
      return 'AnalyticalMean';
      break;
    case 'adaptability':
      return 'AdaptabilityMean';
      break;
    case 'learning agility':
      return 'CommonSenseMean';
      break;
    case 'resourcefulness':
      return 'ProblemSolverMean';
      break;

    //Execution
    case 'focus':
      return 'DirectionMean';
      break;
    case 'responsibility':
      return 'ResponsibilityMean';
      break;
    case 'persuasion':
      return 'CourageMean';
      break;
    case 'discipline':
      return 'StructureMean';
      break;
    break;
  }
}

export function colorForCategory(category){
  switch(category){
    case 'motivation':
      return '#1A1F46';
    break;
    case 'interaction':
      return '#F3CF6A';
    break;
    case 'execution':
      return '#81A65E';
    break;
    case 'cognition':
      return '#A8272C';
    break;
    default:
      return '#041914';
    break;
  }
}

export function getCurrentUser(){
  console.log('calling getCurrentUser');
  console.log(firebase.auth().currentUser);
  return firebase.auth().currentUser;
}

export function organizationId(){
  const currentUser = store.getState().user;

  if(currentUser && currentUser.organizationId){
    return currentUser.organizationId;
  }
  else if(currentUser && currentUser.viewingOrganization){
    console.log('viewing organization: ', currentUser.viewingOrganization);
    return currentUser.viewingOrganization;
  }
  else{
    return null;
  }
}

export function accountId(){
  const currentUser = firebase.auth().currentUser;

  if(currentUser){
    return currentUser.uid;
  }
  else{
    return null;
  }
}

export function currentUserRole(){
  const currentUser = store.getState().user;

  //console.log('currentUserRole evaluated: ', currentUser);

  if(currentUser){
    return currentUser.role;
  }
  else{
    return null;
  }
}

export function currentUserIsEmployee(){
  return currentUserRole() === 'employee' || false;
}
export function currentUserIsManager(){
  return currentUserRole() === 'manager' || false;
}
export function currentUserIsSalesLeader(){
  return currentUserRole() === 'salesleader' || false;
}
export function currentUserIsAdmin(){
  return currentUserRole() === 'admin' || currentUserRole() === 'superadmin' || false;
}
export function currentUserIsSuperAdmin(){
  return currentUserRole() === 'superadmin' || false;
}

export function currentUserHasPermission(permission){
  switch(permission){
    default:
      return false;
    case 'view_people_page':
      return currentUserIsAdmin();
    case 'view_teams_page':
      return currentUserIsManager() || currentUserIsSalesLeader() || currentUserIsAdmin();
    case 'manage_organizations':
      return currentUserIsSuperAdmin();
  }
}

export function generateUnsafeHash(){
  return Math.random().toString(36).substring(2);
}

export function generateSafePassword(){
  const password = passwordGenerator(17, false);
  return password;
}


export function omitDeleted(object){
  return _.omitBy(object, item => {
    return item._deleted;
  });
}

export function addKeysAsIds(objects){
  return _.mapValues(objects, (object, key) => {
    return {
      _id: key,
      ...object
    }
  });
}

export function logAndDispatchErrorForAction(actionName, err, dispatchFunction, dispatchType, callback){
  console.error('Error during', actionName, ':', err);
  dispatchFunction({
    type: dispatchType,
    payload: err.message
  });

  ifCallbackIsFunction(callback);
}

export function unwrapDoc(doc){
  //don't add onto doc if not object
  if(typeof doc.data() !== 'object'){
    return doc.data();
  }

  let unwrappedDoc = {
    ...doc.data()
  };

  unwrappedDoc._id = doc.id;

  return unwrappedDoc;
}

export function unwrapDocs(docs){
  let unwrappedDocs = [];

  docs.forEach(doc => {

    //don't add onto unwrappedDocs if not object
    if(typeof doc.data() !== 'object'){
      return;
    }

    let unwrappedDoc = doc.data();
    unwrappedDoc._id = doc.id;

    unwrappedDocs.push(unwrappedDoc);
  });

  return unwrappedDocs;
}

export function withoutId(object){
  let copy = { ...object };
  delete copy._id;
  return copy;
}
export function withoutIds(objects){
  const copies = _.map(objects, object => {
    return withoutId(object);
  });

  return copies;
}

//initialize sentry for error logging
Sentry.init({
  dsn: CONFIG.SENTRY_CONFIG.DSN,
  maxBreadcrumbs: 0,
  //debug: true,
  //uncomment below to request report from user when error happens
  // beforeSend: event => {
  //   //https://docs.sentry.io/learn/user-feedback/?platform=browser
  //   event.exception && Sentry.showReportDialog();
  //   return event;
  // }
});

export function logError(err){
  console.log('Logging error to Sentry: ', err);
  Sentry.captureException(err);
  console.log('error logged!');
}

export function scopeErrorReportingToUser(user){
  Sentry.configureScope(scope => {
    scope.setUser(user);
  });
}

export function scopeFullstoryCaptureToUser(user){
  if(!isProduction()){
    return;
  }
  FullStoryAPI('identify', user.uid, {
    displayName: user.firstName + ' ' + user.lastName,
    email: user.email,
  });

  // if(typeof FS !== 'undefined'){
  //   FS.identify(user.uid, {
      // displayName: user.firstName + ' ' + user.lastName,
      // email: user.email,
  //     // TODO: Add your own custom user variables here, details at
  //     // http://help.fullstory.com/develop-js/setuservars
  //     // reviewsWritten_int: 14,
  //   });
  // }
}

export function unscopeFullstoryCapture(){
  if(!isProduction()){
    return;
  }
  FullStoryAPI('identify', false);
}

export const Firebase = firebase.initializeApp(CONFIG.FIREBASE_CONFIG);

if(!isProduction() && CONFIG.ADVANCED_DEBUG){
  firebase.firestore.setLogLevel('debug');
}

export const FirebaseForUserCreation = firebase.initializeApp(CONFIG.FIREBASE_CONFIG, "usercreation");

//Allow access to firebase globally
window.firebase = Firebase;
window.generateSafePassword = generateSafePassword;


const firestore = firebase.firestore();
const settings = {
  timestampsInSnapshots: true
};
firestore.settings(settings);

//Allow direct access to firestore globally
window.firestore = firestore;



// WEBPACK FOOTER //
// ./src/util/index.js